import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { pushToast } from "../../components/Toast"

/* Icons */
import { TableIcon, LayersIcon, CloseIcon, CheckIcon, SearchIcon } from "../../components/Icons"
import { TypeIcon } from "../Game/GameIcons"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"


/* Widget GamePicker — THE GAME OF A TABLE IS PICKED FROM THE CATALOGUE, NEVER TYPED BY HAND */
class GamePicker extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            typeID: 0,
            game: "",
            search: "",
        }
    }

    /* Open Action — the type of the current game opens first */
    open = (game = "") => {

        /* Fields */
        const { catalog } = this.props

        /* The Game Of The Table */
        const found = catalog.games.find((item) => item.key === game)

        /* The Type Of That Game, Otherwise The First One */
        const typeID = found ? found.typeID : (catalog.types.length > 0 ? catalog.types[0].id : 0)

        this.setState({ visible: true, typeID, game: `${game}`, search: "" })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, search: "" })
    }

    /* Select A Type — the game of another type must not stay selected */
    selectType = (id) => {

        /* Fields */
        const { catalog } = this.props
        const { game } = this.state

        /* Check The Selected Game */
        const selected = catalog.games.find((item) => item.key === game)
        const keep = selected && parseInt(selected.typeID) === parseInt(id)

        this.setState({ typeID: id, game: keep ? game : "", search: "" })
    }

    /* THE GAMES OF THE OPEN TYPE */
    games = () => {

        /* Fields */
        const { catalog } = this.props
        const { typeID, search } = this.state

        /* Filter By Type — a hidden game of the catalogue is never offered */
        const list = catalog.games.filter((item) => parseInt(item.typeID) === parseInt(typeID) && parseInt(item.visible) === 1)

        /* Check Search */
        if (`${search}`.trim() === "") {
            return list
        }

        /* Filter By Search */
        const value = search.trim().toLowerCase()

        return list.filter((item) => `${item.name} ${item.key} ${item.prefix}`.toLowerCase().includes(value))
    }

    /* Apply Action */
    apply = () => {

        /* Fields */
        const { select } = this.props
        const { game } = this.state

        /* Check Game */
        if (`${game}`.trim() === "") {
            pushToast({ text: t("settings.pickGameChoose"), type: "error" })
            return
        }

        /* Send The Key To The Form */
        select(game)

        this.close()
    }

    /* Draw The Types Of The Catalogue */
    _types = () => {

        /* Fields */
        const { catalog } = this.props
        const { typeID } = this.state

        return (
            <div className="tbl--section">

                <div className="tbl--section-title">
                    <LayersIcon size={14} />
                    {t("game.typeSection")}
                </div>

                <div className="tbl--types">
                    {catalog.types.map((item) =>
                        <div
                            onClick={() => this.selectType(item.id)}
                            className={`tbl--type ${parseInt(typeID) === parseInt(item.id) ? "active" : ""}`}
                            key={`${item.id}`}
                        >
                            <div className="tbl--type-icon"><TypeIcon type={item.key} size={16} /></div>
                            <span>{item.name}</span>
                            {parseInt(item.live) === 1 && <div className="tbl--type-live">Live</div>}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Draw The Games Of The Open Type */
    _games = () => {

        /* Fields */
        const { catalog } = this.props
        const { typeID, game, search } = this.state

        /* Fields */
        const list = this.games()
        const type = catalog.types.find((item) => parseInt(item.id) === parseInt(typeID))

        return (
            <div className="tbl--section">

                <div className="tbl--section-title">
                    <TableIcon size={14} />
                    {t("game.gameSection")}
                    <span className={`tbl--counter ${list.length === 0 ? "empty" : ""}`}>{list.length}</span>
                </div>

                <div className="tbl--search">

                    <SearchIcon size={15} />

                    <input value={search} placeholder={t("common.search")} onChange={(event) => this.setState({ search: event.target.value })} />

                    {search !== "" &&
                        <div onClick={() => this.setState({ search: "" })} className="tbl--search-clear">
                            <CloseIcon size={11} />
                        </div>
                    }

                </div>

                <div className="tbl--pick">
                    {list.map((item) =>
                        <div
                            onClick={() => this.setState({ game: item.key })}
                            className={`tbl--pick-item ${game === item.key ? "active" : ""}`}
                            key={`${item.id}`}
                        >
                            <div className="tbl--pick-symbol"><TypeIcon type={type ? type.key : ""} size={15} /></div>
                            <div className="tbl--pick-text">
                                <h4>{item.name}</h4>
                                <p>{item.prefix ? `${item.prefix} · ${item.key}` : item.key}</p>
                            </div>
                            {game === item.key && <div className="tbl--pick-mark blue"><CheckIcon size={11} /></div>}
                        </div>
                    )}
                </div>

                {/* Empty Type */}
                {list.length === 0 && <div className="tbl--empty">{t("settings.pickGameEmpty")}</div>}

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, game } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="tbl--form-modal"
                overlayClassName="tbl--form-overlay"
                closeTimeoutMS={200}
            >

                <div className="tbl--form-header">

                    <div className="tbl--modal-icon blue">
                        <TableIcon size={18} />
                    </div>

                    <div className="tbl--modal-head-text">
                        <h2>{t("settings.pickGame")}</h2>
                        <p>{t("settings.pickGameHint")}</p>
                    </div>

                    <div onClick={() => this.close()} className="tbl--modal-close">
                        <CloseIcon size={16} />
                    </div>

                </div>

                <div className="tbl--form-body">

                    {/* Draw Types */}
                    {this._types()}

                    {/* Draw Games */}
                    {this._games()}

                </div>

                <div className="tbl--form-footer">

                    <div onClick={() => this.close()} className="tbl--button ghost">{t("common.cancel")}</div>

                    <div onClick={() => this.apply()} className={`tbl--button primary ${game === "" ? "disabled" : ""}`}>{t("common.select")}</div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    catalog: state.catalog,
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(GamePicker)
